module.exports = __webpack_public_path__ + "static/media/55_000071.1f97da0f.jpg";